import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { About } from '@/screens/About';

//data-helpers
import { JsonLd } from '@/datafiles/micro-data/';
import { Awards } from '@/datafiles/micro-data/awards';

export default function AboutPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="about loadsmart, loadsmart, logistics companies, logistics companies chicago, freight tech,"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="About Us | Loadsmart"
        description="Loadsmart is changing freight technology to empower businesses to move more with less offering freight brokerage, shipping, carrier and warehouse services."
        canonical="https://loadsmart.com/about/"
        openGraph={{
          url: 'https://loadsmart.com/about/',
        }}
      />
      <JsonLd data={Awards} />
      <About />
    </>
  );
}
